export class ElasticPagination {

    public pageSize = 10;
    public pageIndex = 1;
}
